import http from './http';

export default {
  // 发送短信验证码
  send(data) {
    return http.post('/Sms/send', data);
  },
  
  // 验证短信验证码
  verify(data) {
    return http.post('/Sms/check', data);
  },
  
  // 检查手机号是否可以注册/使用
  checkMobile(data) {
    return http.post('/Sms/checkMobile', data);
  }
};
